<app-thi-page-shell [lang]="landingLang">
<div class="terms-of-service pt-20">
	<div class="container">
		
		<div class="terms-of-service__header">
			<div class="terms-of-service__header-content">
				<h1 class="terms-of-service__title">
					{{ 'termsOfService.title' | translate }}
				</h1>
				<p class="terms-of-service__subtitle">
					{{ 'termsOfService.subtitle' | translate }}
				</p>
			</div>
		</div>

		<div class="terms-of-service__container">
			
			<p-card class="terms-of-service__card">
				<ng-template pTemplate="header">
					<div class="terms-of-service__card-header">
						<div class="terms-of-service__last-updated">
							<i class="pi pi-calendar"></i>
							<span>{{ 'termsOfService.lastUpdated' | translate }}: {{ 'termsOfService.lastUpdatedDate' | translate }}</span>
						</div>
					</div>
				</ng-template>

				<div class="terms-of-service__content">
					
					<div class="terms-of-service__section">
						<h2 class="terms-of-service__section-title">{{ 'termsOfService.sections.introduction.title' | translate }}</h2>
						<p>{{ 'termsOfService.sections.introduction.content1' | translate }}</p>
						<p>{{ 'termsOfService.sections.introduction.content2' | translate }}</p>
					</div>

					<div class="terms-of-service__section">
						<h2 class="terms-of-service__section-title">{{ 'termsOfService.sections.service.title' | translate }}</h2>
						<p>{{ 'termsOfService.sections.service.content1' | translate }}</p>
						<p>{{ 'termsOfService.sections.service.content2' | translate }}</p>
						<p>{{ 'termsOfService.sections.service.content3' | translate }}</p>
						<p>{{ 'termsOfService.sections.service.content4' | translate }}</p>
					</div>

					<div class="terms-of-service__section">
						<h2 class="terms-of-service__section-title">{{ 'termsOfService.sections.registration.title' | translate }}</h2>
						<p>{{ 'termsOfService.sections.registration.content1' | translate }}</p>
						<p>{{ 'termsOfService.sections.registration.content2' | translate }}</p>
					</div>

					<div class="terms-of-service__section">
						<h2 class="terms-of-service__section-title">{{ 'termsOfService.sections.userResponsibility.title' | translate }}</h2>
						<p>{{ 'termsOfService.sections.userResponsibility.content1' | translate }}</p>
						<p>{{ 'termsOfService.sections.userResponsibility.content2' | translate }}</p>
						<p>{{ 'termsOfService.sections.userResponsibility.content3' | translate }}</p>
					</div>

					<div class="terms-of-service__section">
						<h2 class="terms-of-service__section-title">{{ 'termsOfService.sections.operatorResponsibility.title' | translate }}</h2>
						<p>{{ 'termsOfService.sections.operatorResponsibility.content1' | translate }}</p>
						<p>{{ 'termsOfService.sections.operatorResponsibility.content2' | translate }}</p>
						<p>{{ 'termsOfService.sections.operatorResponsibility.content3' | translate }}</p>
					</div>

					<div class="terms-of-service__section">
						<h2 class="terms-of-service__section-title">{{ 'termsOfService.sections.payment.title' | translate }}</h2>
						<p>{{ 'termsOfService.sections.payment.content1' | translate }}</p>
						<p>{{ 'termsOfService.sections.payment.content2' | translate }}</p>
					</div>

					<div class="terms-of-service__section">
						<h2 class="terms-of-service__section-title">{{ 'termsOfService.sections.intellectualProperty.title' | translate }}</h2>
						<p>{{ 'termsOfService.sections.intellectualProperty.content1' | translate }}</p>
						<p>{{ 'termsOfService.sections.intellectualProperty.content2' | translate }}</p>
					</div>

					<div class="terms-of-service__section">
						<h2 class="terms-of-service__section-title">{{ 'termsOfService.sections.governingLaw.title' | translate }}</h2>
						<p>{{ 'termsOfService.sections.governingLaw.content1' | translate }}</p>
					</div>

					<div class="terms-of-service__contact">
						<h2 class="terms-of-service__section-title">{{ 'termsOfService.contact.title' | translate }}</h2>
						<p>{{ 'termsOfService.contact.description' | translate }}</p>
						<div class="terms-of-service__contact-info">
							<i class="pi pi-envelope"></i>
							<span>{{ 'termsOfService.contact.email' | translate }}</span>
						</div>
					</div>
				</div>

			</p-card>

		</div>
	</div>
</div>
</app-thi-page-shell>
